import { Component, OnInit, Inject,  OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StaticMediaResult } from '../../../models/static/StaticMediaResult';
import { Subscription } from 'rxjs';
import { AuthGuardService } from '../../../services/auth-guard.service';

export interface DialogData<T> {
    svgmap: T;
    desktopTemplate: boolean;
    alternatives: boolean;
}

@Component({
    selector: 'app-svgmapinfo',
    templateUrl: './svgmapinfo.component.html',
    styleUrls: ['./svgmapinfo.component.scss'],
    standalone: false
})
export class SvgmapinfoComponent implements OnInit, OnDestroy {
    private subscribes: Subscription[] = [];
    html: string;
    name: string = '';
    title: string = '';
    code: string = '';
    contentid: string = '';
    image: string = '';
    text: string = '';
    desktopTemplate: boolean = true;
    svgmap: {
        name: '',
        code: '',
        contentid: '',
        image: '',
        title: '',
        text: '',
    };

    loading: boolean = true;
    hts: StaticMediaResult;
    partner: any;
    alternativeCatalogList = [];

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: DialogData<any>,
        private dialogRef: MatDialogRef<SvgmapinfoComponent>,
        private guardService: AuthGuardService
    ) { }

    ngOnInit(): void {
        this.html = this.data?.svgmap?.catalogData?.html;
        this.name = this.data?.svgmap?.name;
        this.title = this.data?.svgmap?.title;
        this.text = this.data?.svgmap?.text;
        this.code = this.data?.svgmap?.code;
        this.contentid = this.data?.svgmap?.contentid;
        this.image = this.data?.svgmap?.image;
        this.desktopTemplate = this.data.desktopTemplate;
        this.svgmap = this.data?.svgmap;
        this.loading = false;
    }

    gotoContent() {
        const partner = this.guardService.getPartner();
        if (partner?.partnerdomain?.length > 0) {
            window && window.open('https://' + partner.partnerdomain + '/reisekompass/' + this.contentid)
        } else {
            const url = document.location.origin;
            window && window.open(url + '/' + this.guardService.getPartnerId() + '/reisekompass/' + this.contentid)
        }
        this.dialogRef.close();
    }

    
    ngOnDestroy(): void {
        this.subscribes.forEach(element => {
            element.unsubscribe();
        });
    }
}
